<div *ngIf="idleWatcher.showPrompt()" class="modal-backdrop">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-clock-history"></i>
          ¿Deseas mantener tu sesión activa?
        </h5>
      </div>
      <div class="modal-body">
        <p class="mb-0">
          Tu sesión ha estado inactiva por un tiempo prolongado. Por seguridad, se cerrará
          automáticamente si no respondes.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light px-4 fw-medium" (click)="onDecline()">
          No, cerrar sesión
        </button>
        <button type="button" class="btn btn-primary px-4 fw-bold shadow-sm" (click)="onConfirm()">
          Sí, mantener sesión
        </button>
      </div>
    </div>
  </div>
</div>
